import { CONTRACT_PAGE_FIXED_FEES_COLUMNS_KEYS } from './contract-fixed-fees-columns-keys';

export const CONTRACT_PAGE_FIXED_FEES_MANDATORY_COLUMNS_KEYS = [
  CONTRACT_PAGE_FIXED_FEES_COLUMNS_KEYS.PRODUCT_NAME,
  CONTRACT_PAGE_FIXED_FEES_COLUMNS_KEYS.PRICING_TYPE,
  CONTRACT_PAGE_FIXED_FEES_COLUMNS_KEYS.AMOUNT,
  CONTRACT_PAGE_FIXED_FEES_COLUMNS_KEYS.QUANTITY,
];
